
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export function TabContentSkeleton() {
  return (
    <div 
      className="space-y-4 p-4 w-full" 
      style={{ 
        height: '800px', 
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'opacity 0.3s ease-in-out',
        contain: 'layout size style'
      }}
    >
      <div className="flex-1">
        <div className="flex items-center gap-4 mb-6">
          <Skeleton className="h-8 w-8" />
          <div>
            <Skeleton className="h-6 w-48 mb-2" />
            <Skeleton className="h-4 w-32" />
          </div>
        </div>
        <Skeleton className="h-10 w-full mb-6" />
        <Skeleton className="h-48 w-full mb-4" />
        <Skeleton className="h-48 w-full mb-4" />
        <Skeleton className="h-48 w-full mb-4" />
      </div>
      <div className="h-40 w-full">
        <Skeleton className="h-full w-full" />
      </div>
    </div>
  );
}
